/* eslint-disable no-console */
import ServiceBase from './serviceBase';
import {
  FlowCreate,
  FlowContainer,
  FlowNextReview,
  FlowFeedbackProvided,
  OperFlowService,
  FlowFeedbackForSave,
  InviteReviewers,
  FlowRestart,
  FlowRelate,
  FlowReviewerDelete,
  FlowEsapInfo,
  FlowSprMission,
  FlowSprDoc,
} from './types/Flow';

const NOT_IMPLEMENTED_ERROR_MESSAGE = 'Not Implemented';

class OperInitialEsrsService extends ServiceBase implements OperFlowService {
  create = async (data: FlowCreate): Promise<number> =>
    this.post<number>('operationInitialEsrs/create', data);

  getFlow = async (operationId: number): Promise<FlowContainer> =>
    this.get<FlowContainer>(`operationInitialEsrs/${operationId}`);

  sendForNextReview = async (data: FlowNextReview): Promise<void> =>
    this.post<void>('operationInitialEsrs/next', data);

  provideFeedback = async (data: FlowFeedbackProvided): Promise<void> =>
    this.post<void>('operationInitialEsrs/feedback', data);

  saveFeedback = async (data: FlowFeedbackForSave): Promise<void> =>
    this.post<void>('operationInitialEsrs/savefeedback', data);

  applyComplianceChanges = async (flowId: number): Promise<void> =>
    this.post<void>(`operationInitialEsrs/${flowId}/applycompliance`);

  discardComplianceChanges = async (flowId: number): Promise<void> =>
    this.post<void>(`operationInitialEsrs/${flowId}/discardcompliance`);

  openWord = async (flowId: number): Promise<string> =>
    this.post<string>(`operationInitialEsrs/${flowId}/wordlink`);

  downloadDocVersion = async (id: number): Promise<boolean> => {
    await this.download(`operationInitialEsrs/version/${id}`);
    return true;
  };

  upload = async (formData: FormData): Promise<boolean> => {
    const result = await this.post<boolean>('operationInitialEsrs/upload', formData);
    return result;
  };

  restart = async (data: FlowRestart): Promise<void> =>
    this.post<void>('operationInitialEsrs/restart', data);

  relate = async (data: FlowRelate): Promise<void> =>
    this.post<void>('operationInitialEsrs/relate', data);

  inviteReviewers = async (data: InviteReviewers): Promise<void> =>
    this.post<void>('operationInitialEsrs/invite-reviewers', data);

  applyActionPlanChanges = async (flowId: number): Promise<void> => {
    console.log(flowId);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  discardActionPlanChanges = async (flowId: number): Promise<void> => {
    console.log(flowId);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  applyIndicatorsChanges = async (flowId: number): Promise<void> => {
    console.log(flowId);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  discardIndicatorsChanges = async (flowId: number): Promise<void> => {
    console.log(flowId);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  getSPRRationale = async (flowId: number): Promise<FlowSprDoc> => {
    console.log(flowId);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  getSPRMissions = async (operationId: number): Promise<FlowSprMission[]> => {
    console.log(operationId);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  removeReviewers = async (data: FlowReviewerDelete): Promise<void> =>
    this.post<void>('operationInitialEsrs/remove-reviewers', data);

  checkEsap = async (flowId: number): Promise<FlowEsapInfo> => {
    console.log(flowId);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  deleteFlow = async (flowId: number, lap?: number | undefined) => {
    let uri = `operationInitialEsrs/${flowId}`;
    if (lap) {
      uri = `${uri}/${lap}`;
    }
    return this.delete<void>(uri);
  };
}

const operInitialEsrsService = new OperInitialEsrsService();

export default operInitialEsrsService;
